import {
  gql,
} from '@apollo/client';

const BILLING_ADDRESS_CONFIG_QUERY = gql`
  query getBillingAddressConfig($country: String!) {
    billingAddressConfig(country: $country) {
      addressFields {
        label
        errorMessage
        id
        name
        component
        type
        visibility
        maxLength
        validationRule
        required
        defaultValue
        labelFor
        options {
          label
          value
          options {
            label
            value
          }
        }
      }
      isAddressyEnabled
    }
  }
`;

export default BILLING_ADDRESS_CONFIG_QUERY;
